const angular = require('angular');

export default angular.module('nomasvelloDashboardApp.monthlySelling.cashDeskReportRow', [])
  .directive('cashDeskReportRow', function () {
    return {
      template: require('./cashDeskReportRow.pug'),
      replace: true,
      restrict: 'C'
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/manager/monthlySelling/directives/cashDeskReportRow/index.ts